import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface CountryOption {
  value: string;
  label: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private cache$: Observable<CountryOption[]> | null = null;

  constructor(private readonly http: HttpClient) {}

  /**
   * Returns list of countries from cncs-core API (value = code_alpha_2, label = name).
   * Fetched from cncsCoreUrl, result is cached for the session.
   */
  getCountries(): Observable<CountryOption[]> {
    if (!this.cache$) {
      const base = (environment.cncsCoreUrl ?? '').replace(/\/+$/, '');
      const url = `${base}/api/countries`;
      this.cache$ = this.http.get<CountryOption[]>(url).pipe(
        catchError(() => of([])),
        shareReplay(1)
      );
    }
    return this.cache$;
  }
}
